module.exports = __webpack_public_path__ + "static/media/Share Learning Materials.139320a2.png";